import { defineMessages } from 'react-intl';

import type { MessageDescriptor } from 'react-intl';

export enum OrgUserCountError {
	Required = 'required',
	NotANumber = 'notANumber',
	NotInteger = 'notInteger',
	TooSmall = 'tooSmall',
	TooLarge = 'tooLarge',
}

export const ORG_USER_COUNT_MIN = 1;
export const ORG_USER_COUNT_MAX = 1_000_000;

export const orgUserCountErrorMessages: Record<OrgUserCountError, MessageDescriptor> =
	defineMessages({
		required: {
			id: 'ubpQ4.usage.orgUserCount.error.required',
			defaultMessage: 'Enter a number for this field.',
		},
		notANumber: {
			id: 'ubpQ4.usage.orgUserCount.error.notANumber',
			defaultMessage: 'Field must be a number.',
		},
		notInteger: {
			id: 'ubpQ4.usage.orgUserCount.error.notInteger',
			defaultMessage: 'Field must be a whole number.',
		},
		tooSmall: {
			id: 'ubpQ4.usage.orgUserCount.error.tooSmall',
			defaultMessage: 'Field must be at least {min, number}.',
		},
		tooLarge: {
			id: 'ubpQ4.usage.orgUserCount.error.tooLarge',
			defaultMessage: 'Field must be at most {max, number}.',
		},
	});

export const validateOrgUserCount = (value: number | undefined): OrgUserCountError | undefined => {
	if (value === undefined) {
		return OrgUserCountError.Required;
	}
	if (Number.isNaN(value)) {
		return OrgUserCountError.NotANumber;
	}
	if (!Number.isInteger(value)) {
		return OrgUserCountError.NotInteger;
	}
	if (value < ORG_USER_COUNT_MIN) {
		return OrgUserCountError.TooSmall;
	}
	if (value > ORG_USER_COUNT_MAX) {
		return OrgUserCountError.TooLarge;
	}
	return undefined;
};
